import React from 'react';
import { graphql } from 'gatsby';

import { useLanguage } from '../hooks/useLanguage';
import languages from '../data/languages';

export default function RedirectIndex(args) {
  const { getLangKeyFromBrowserSettings } = useLanguage();

  if (typeof window !== 'undefined') {
    const { gatsbyPathsHome } = args.data;
    const gatsbyPathHome = gatsbyPathsHome.edges
      .map((e) => e.node)
      .filter(
        (n) => n.node_locale === getLangKeyFromBrowserSettings(languages)
      );
    window.___replace(gatsbyPathHome[0].gatsbyPath);
  }
  return <div />;
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
        }
      }
    }
    gatsbyPathsHome: allContentfulPage(filter: { name: { eq: "home" } }) {
      edges {
        node {
          node_locale
          name
          gatsbyPath(
            filePath: "/{ContentfulPage.node_locale}/{ContentfulPage.slug}"
          )
        }
      }
    }
  }
`;
